"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identity = void 0;
/**
 * A generic function that returns its input unchanged.
 * This function is useful in various functional programming scenarios, such as:
 * - Creating higher-order functions like map, filter, and reduce.
 * - Composing functions by providing an "identity element" in function composition.
 *
 * @template T - The type of the input value.
 * @param {T} value - The value to return unchanged.
 * @returns {T} The input value, unchanged.
 */
function identity(value) {
    return value;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map